import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/siteData";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  const toggle = (id: string) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section id="faq" className="scroll-mt-20 border-t border-background-200/70 bg-background-100">
      <div className="mx-auto w-full px-4 py-16 md:px-8 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="常见问题"
            title="关于本站，你可能想问的"
            description="关于内容范围、浏览方式与目录使用的常见疑问，先在这里一次性说清楚。"
          />
        </Reveal>

        <div className="mt-10 grid gap-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
          <Reveal>
            <div className="rounded-lg border border-background-200 bg-background-50 p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-question-answer-line text-lg" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">还有什么想了解的？</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                本站是纯浏览型页面，不收集信息、不需要登录。如果你在使用目录时遇到疑惑，先看看右侧的常见问题，
                大部分情况都能找到答案。
              </p>
              <ul className="mt-5 space-y-2.5 text-sm text-foreground-600">
                {["无需注册登录", "目录本地筛选", "条目标注更新时间"].map((item) => (
                  <li key={item} className="flex items-center gap-2">
                    <i className="ri-check-line text-accent-600" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={100}>
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((item) => {
                const isOpen = openId === item.id;
                return (
                  <div key={item.id}>
                    <h3>
                      <button
                        type="button"
                        onClick={() => toggle(item.id)}
                        aria-expanded={isOpen}
                        className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100"
                      >
                        <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                          {item.question}
                        </span>
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600">
                          <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} />
                        </span>
                      </button>
                    </h3>
                    {isOpen ? (
                      <div className="px-5 pb-5">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}